// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1xBf6","validationTips":"StatementDescriptor_validationTips__2W6rx"};